import { colors } from '@lmc/common/constants'
import { Col, Row } from 'antd'
import type * as React from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { Link } from 'react-router-dom'
import Icon from '../../../general/Icon'
import type IconType from '../../../general/Icon/iconTypes'
import Container from '../../atoms/Container'
import Text from '../../atoms/Text'
import style from './ModuleCard.module.less'

export type ModuleCardProps = {
  backgroundColor: string
  height?: number
  icon:
    | IconType.CarePlansHexagon
    | IconType.DocsHexagon
    | IconType.EmarHexagon
    | IconType.FamilyHexagon
    | IconType.GroupsHexagon
    | IconType.ProHexagon
  link: string
  linkText?: string
  mobileHeight?: number
  onClick?: () => void
  subtitle: string
  title: string
}

export default function ModuleCard({
  backgroundColor,
  height = 270,
  icon,
  link,
  mobileHeight = 225,
  onClick,
  subtitle,
  title
}: ModuleCardProps) {
  const isDesktop = isTablet || isBrowser

  const containerStyle = {
    ...styles.wrapper,
    minHeight: isDesktop ? height : mobileHeight
  }
  const topRowStyle = { backgroundColor, ...styles.topRow }
  const bottomRowStyle = {
    backgroundColor: colors.white,
    ...styles.bottomRow
  }
  const iconContainerStyle = {
    height: isDesktop ? 140 : 100
  }

  return (
    <Link to={link} onClick={onClick}>
      <Container backgroundColor={colors.white} style={containerStyle}>
        <>
          <Row justify="center" style={topRowStyle}>
            <Col span={11} style={styles.titleColumn}>
              <Text
                style={styles.title as React.CSSProperties}
                className={style.title}
              >
                {title}
              </Text>
            </Col>
            <Col span={11}>
              <div style={iconContainerStyle}>
                <Icon
                  customIcon={icon}
                  height={isDesktop ? 200 : 166.06}
                  style={styles.icon}
                  width={isDesktop ? 183 : 151.41}
                />
              </div>
            </Col>
          </Row>
          <Row justify="center" style={bottomRowStyle}>
            <Col span={11}>
              <Text as="p1" style={styles.subtitle}>
                {subtitle}
              </Text>
            </Col>
            <Col span={11} />
          </Row>
        </>
      </Container>
    </Link>
  )
}

const styles = {
  bottomRow: {
    borderRadius: '0px 0px 25px 25px',
    marginLeft: 4,
    marginRight: 4,
    marginTop: 'auto',
    marginBottom: 'auto'
  },
  icon: {
    width: '100%',
    transform: 'translate(0px, 20px)'
  },
  subtitle: {
    lineHeight: '20px'
  },
  topRow: {
    textAlign: 'center' as const,
    borderRadius: 25
  },
  title: {
    color: colors.white,
    fontSize: 52,
    fontWeight: 700,
    lineHeight: '35.5px',
    textAlign: 'justify'
  },
  titleColumn: {
    marginTop: 'auto',
    display: 'flex',
    marginBottom: '10px'
  },
  wrapper: {
    padding: '0px',
    display: 'flex',
    flexDirection: 'column' as const
  }
}
